import { render } from "./PowerDetails.vue?vue&type=template&id=2ed6b0c1"
import script from "./PowerDetails.vue?vue&type=script&lang=js"
export * from "./PowerDetails.vue?vue&type=script&lang=js"

import "./PowerDetails.vue?vue&type=style&index=0&id=2ed6b0c1&lang=scss"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__